// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

ion-card ion-icon.has-equipment {
  float: right;
}
ion-card ion-card-title, ion-card ion-card-subtitle, ion-card ion-label {
  color: black;
}
ion-card ion-card-subtitle.status-badge {
  text-align: right;
}
ion-card ion-card-subtitle.status-badge ion-badge {
  margin-left: 5px;
}

.equipment-status {
  background-color: var(--grey-bg-color);
}

.equipment-status.new-pending-approval {
  background-color: var(--dark-blue-bg);
}

.equipment-status.updated-pending-approval {
  background-color: var(--dark-blue-bg);
}`, "",{"version":3,"sources":["webpack://./src/app/components/equipment-card/equipment-card.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAII;EACI,YAAA;AADR;AAII;EACI,YAAA;AAFR;AAKI;EACI,iBAAA;AAHR;AAKQ;EACI,gBAAA;AAHZ;;AAQA;EACI,sCAAA;AALJ;;AAQA;EACI,qCAAA;AALJ;;AAQA;EACI,qCAAA;AALJ","sourcesContent":[":host {\r\n    width: 100%;\r\n}\r\n\r\nion-card {\r\n\r\n    ion-icon.has-equipment {\r\n        float: right;\r\n    }\r\n\r\n    ion-card-title, ion-card-subtitle, ion-label {\r\n        color: black;\r\n    }\r\n\r\n    ion-card-subtitle.status-badge {\r\n        text-align: right;\r\n\r\n        ion-badge {\r\n            margin-left: 5px;\r\n        }\r\n    }\r\n}\r\n\r\n.equipment-status {\r\n    background-color: var(--grey-bg-color);\r\n}\r\n\r\n.equipment-status.new-pending-approval {\r\n    background-color: var(--dark-blue-bg);\r\n}\r\n\r\n.equipment-status.updated-pending-approval {\r\n    background-color: var(--dark-blue-bg);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
